import React from "react";
import { GoogleMaps } from "../GoogleMaps/GoogleMaps";

export const Pickup = () => {
  return <GoogleMaps orderType="pickup" />;
};
